const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const isMobile = Odigeo.SessionScope.flow === 'mobile';

module.exports = withRenderedMain(BaseView.extend({

    selectors: {
        fareOptionInfoContainer: '.fare_option_info_container',
        hintContainer: '.hint_container',
    },

    events: {
        'tap .hint_close': 'onTapCloseHint',
    },

    initialize() {
        this.enhanceHint();
    },

    enhanceHint() {
        const events = isMobile ? {tap: true} : {hover: true};
        Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), this.$el.find(this.selectors.fareOptionInfoContainer), {events});
    },

    onTapCloseHint() {
        this.toggleHint(false);
    },

    toggleHint(toggle) {
        this.$el.find(this.selectors.hintContainer).toggleClass('opened', toggle);
    },

}));
